import { FC, Fragment, useContext, useEffect, useMemo } from 'react'
import AccordionContainer from '../Accordion'
import MedicineCard from './MedicineCard'
import { useGet } from 'src/hooks/useGet'
import { GetHospitalsMedicines } from 'src/requests/Shared'
import { useLocation } from 'react-router-dom'
import { Skeleton } from '../Skeleton/Skeleton'
import { Alert } from '../Alert'
import { useTranslation } from 'react-i18next'
import { privilegesContext } from 'src/context/privileges'
import { getHospitalConfiguralion } from 'src/utils'
import "./style.css"
interface IMedicinesPopup {
    ApiMethod?: any
    isParamsValid: boolean
    depArrItems: any[]
    applyAction?: Function
    params: any
    defaultValue: []
    medicineList: any[]
    setMedicineList: Function
    ApproveDoctorRequest?: boolean | null
    title?: string
    recordID: null | number
    hospitalId?: number | null
    isManual?: boolean
    hasEssentialCheckbox?: boolean
    decisionId?: number | null,
    coveredMonth?: number,
    setCoveredMonth?: (item: number) => void
    isCustomAmount?: boolean
}

const ALLOWED_MONTHS_TO_COVER = [
    { label: "oneMonth", value: 1 },
    { label: "twoMonth", value: 2 },
    { label: "threeMonth", value: 3 }
]

const MedicinesSubmitionPopup: FC<IMedicinesPopup> = ({ isManual, applyAction, recordID, hospitalId, ApproveDoctorRequest, medicineList, setMedicineList, ApiMethod, isParamsValid, depArrItems, params, defaultValue = [], hasEssentialCheckbox = false, decisionId, coveredMonth, setCoveredMonth, isCustomAmount }) => {
    const { hospitalCofigurations } = useContext(privilegesContext)

    const { state } = useLocation()
    const { t } = useTranslation()
    const { data: medicinesList, isPending: isPendingMedicines, setData: setMedicinesList, error } = useGet({ API: ApiMethod, isNotValid: !isParamsValid, depArr: depArrItems, params: params, defaultValue: defaultValue })

    const { data: medicineLookup } = useGet({
        API: GetHospitalsMedicines,
        isNotValid: !hospitalId || !recordID,
        depArr: [state?.pharmName, hospitalId, recordID],
        params: [state?.pharmName?.value, hospitalId, false],
        defaultValue: [],
        needSpinner: false
    })

    const isHospitalAllowedToDispenseMoreThanOne = useMemo(() =>
        getHospitalConfiguralion(hospitalCofigurations, 'AllowToDispenseMedicinesForMoreThanOneMonthInOneRequest'), [hospitalCofigurations])

    useEffect(() => {
        if (!isHospitalAllowedToDispenseMoreThanOne?.isAllowed || !setCoveredMonth) return
        if (isHospitalAllowedToDispenseMoreThanOne.value) {
            setCoveredMonth?.(Number(isHospitalAllowedToDispenseMoreThanOne?.value))
        }
    }, [hospitalCofigurations, recordID])

    useEffect(() => {
        applyAction && applyAction(medicinesList)
    }, [medicinesList])

    useEffect(() => {
        setMedicineList([])
        setMedicinesList([])
    }, [recordID])

    return (
        <AccordionContainer>
            {isPendingMedicines ?
                <Skeleton variant='text' width='100%' height='100px' className='my-4' />
                :
                !medicinesList || !medicinesList.length ?
                    <div className='p-3 mb-3'>
                        <Alert variant='danger' >
                            {error}
                        </Alert>
                    </div>
                    :
                    <>
                        {medicinesList?.map((item: any, index: number) => (
                            <Fragment key={item?.requestMedicineId}>
                                <MedicineCard
                                    isManual={isManual}
                                    medicineLookup={medicineLookup}
                                    recordID={recordID}
                                    hospitalId={hospitalId}
                                    ApproveDoctorRequest={ApproveDoctorRequest}
                                    medicineList={medicineList}
                                    setMedicineList={setMedicineList}
                                    item={item}
                                    index={index}
                                    hasEssentialCheckbox={hasEssentialCheckbox}
                                    decisionId={decisionId}
                                    coveredMonths={coveredMonth}
                                // isCustomAmount={isCustomAmount}
                                >
                                </MedicineCard>
                            </Fragment>
                        ))}
                        {isHospitalAllowedToDispenseMoreThanOne?.isAllowed && coveredMonth && setCoveredMonth &&
                            <div className='py-2'>
                                <p>{t("numberOfCoverdMonths")}</p>
                                <div className='col-md-6 col-sm-12 covered-months-selection justify-content-start'>
                                    {ALLOWED_MONTHS_TO_COVER.map((item) => (
                                        <button
                                            className={
                                                `pointer covered-month-item ${coveredMonth === item.value ? 'selected' : ""}`}
                                            disabled={!!isHospitalAllowedToDispenseMoreThanOne?.value}
                                            onClick={() => setCoveredMonth(item.value)}
                                            key={item.value}
                                        >
                                            {t(item.label)}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        }
                    </>
            }
        </AccordionContainer>
    )
}

export default MedicinesSubmitionPopup